import React from "react";
import "./Sidebar.css";
import Logo from "../Logo";
import { X } from "lucide-react";
import { Link as RouterLink } from "react-router-dom";
import { useGlobalContent } from "../GlobalContent";

// The navbar's menu titles (admin: Website → Navbar, footer & offices). Shows the English
// titles in both languages, as it always has.
const Sidebar = ({ openSidebar, onClose }) => {
  const { en, isFR } = useGlobalContent();
  return (
    <div className={`sidebar ${openSidebar ? "visible" : ""}`}>
      <div className="sidebar__wrapper">
        <div className="flex__center top">
          <Logo />
          <button className="flex__center icon" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="middle navlinks">
          {(en.nav.items || []).map((nav, index) => renderNavItem(nav, index, isFR))}
        </div>
      </div>
    </div>
  );
};

function renderNavItem(item, idx, isFR = false) {
  // don't render a RouterLink when there's no link
  const link = item?.link;
  if (!link) return null;

  // "/#services" is a homepage section anchor (e.g. "services", "team", "about").
  // Render as a hash link so navigation scrolls instead of triggering the
  // SPA route /services etc. (which 301-redirects per vercel.json).
  if (/^\/#./.test(link)) {
    const homePrefix = isFR ? "/fr" : "/";
    const anchor = `${homePrefix}#${link.slice(2)}`.replace("//#", "/#");
    return (
      <a key={idx} href={anchor} className="sidebar-link">
        {item.label}
      </a>
    );
  }

  if (/^\/(?!\/)/.test(link)) {
    return (
      <RouterLink key={idx} to={link} className="sidebar-link">
        {item.label}
      </RouterLink>
    );
  }

  // external links
  return (
    <a
      key={idx}
      href={link}
      className="sidebar-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      {item.label}
    </a>
  );
}

export default Sidebar;
